import { render, staticRenderFns } from "./proccessedListItemComponent.vue?vue&type=template&id=64ac45b6&scoped=true"
import script from "./proccessedListItemComponent.vue?vue&type=script&lang=js"
export * from "./proccessedListItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac45b6",
  null
  
)

export default component.exports